import React from "react";
import { Link } from "react-router-dom";
import styles from "./Parser.module.css";

const LINK_TOKEN_PATTERN = /\[([^\]]+)\]\(([^)]+)\)/g;

const isExternalLink = (url) =>
	/^https?:\/\//i.test(url) || url.startsWith("mailto:") || url.startsWith("tel:");

const buildLinkClassName = (linkClassName) =>
	[styles.answerLink, linkClassName].filter(Boolean).join(" ");

const renderLinkNode = (url, label, key, linkClassName) => {
	const className = buildLinkClassName(linkClassName);

	if (isExternalLink(url)) {
		return (
			<a
				key={key}
				href={url}
				target="_blank"
				rel="noopener noreferrer"
				className={className}
			>
				{label}
			</a>
		);
	}

	return (
		<Link key={key} to={url} className={className}>
			{label}
		</Link>
	);
};

export const parseTextWithLinks = (text, linkClassName) => {
	if (typeof text !== "string") {
		return text;
	}

	LINK_TOKEN_PATTERN.lastIndex = 0;
	const parts = [];
	let lastIndex = 0;
	let match;

	while ((match = LINK_TOKEN_PATTERN.exec(text)) !== null) {
		const [fullMatch, label, url] = match;
		const matchStart = match.index;

		if (matchStart > lastIndex) {
			parts.push(text.slice(lastIndex, matchStart));
		}

		parts.push(renderLinkNode(url, label, `token-link-${matchStart}`, linkClassName));
		lastIndex = matchStart + fullMatch.length;
	}

	if (lastIndex < text.length) {
		parts.push(text.slice(lastIndex));
	}

	return parts.length > 0 ? parts : text;
};

function Parser({ text, linkClassName }) {
	return <>{parseTextWithLinks(text, linkClassName)}</>;
}

export default Parser;
